<template>
  <div class="m-scan__mask">
    <div class="m-scan">
      <header class="m-scan__head">
        <span>{{ $t("returns.scan.title") }}</span>
        <button class="m-scan__close" @click="close" :aria-label="$t('returns.scan.close')">
          <i class="material-icons">close</i>
        </button>
      </header>

      <div v-if="!supported" class="m-scan__unsupported">
        {{ $t("returns.scan.notSupported") }}
      </div>
      <template v-else>
        <video ref="video" class="m-scan__video" autoplay playsinline muted></video>
        <p class="m-scan__hint">{{ $t("returns.scan.hint") }}</p>
      </template>
    </div>
  </div>
</template>

<script>
// Live-Barcode-Scan ueber die native BarcodeDetector-API (Android/macOS Chrome).
// Ohne API (iOS Safari, Firefox) zeigt das Overlay einen Hinweis - der Kern-Flow haengt
// nie am Scanner: die Referenz laesst sich immer tippen, die Server-Extraktion (Phase E)
// liest das Label-Foto. DHL-Referenz = Code 128, Identcode/Leitcode = ITF, EAN-Sticker = EAN-13.
export default {
  name: "MBarcodeScanner",
  data() {
    return {
      supported: "BarcodeDetector" in window,
      stream: null,
      timer: null,
      detector: null,
    };
  },
  async mounted() {
    if (!this.supported) return;
    try {
      this.detector = new window.BarcodeDetector({ formats: ["code_128", "itf", "ean_13", "qr_code"] });
      this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
      this.$refs.video.srcObject = this.stream;
      this.timer = setInterval(this.detect, 300);
    } catch (e) {
      this.supported = false;
    }
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    async detect() {
      const video = this.$refs.video;
      if (!video || video.readyState < 2) return;
      try {
        const codes = await this.detector.detect(video);
        if (codes && codes.length) {
          const value = (codes[0].rawValue || "").trim();
          if (value) {
            this.cleanup();
            this.$emit("scanned", { value, format: codes[0].format });
          }
        }
      } catch (e) {
        // einzelner Frame-Fehler ist egal
      }
    },
    close() {
      this.cleanup();
      this.$emit("close");
    },
    cleanup() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.stream) {
        this.stream.getTracks().forEach((t) => t.stop());
        this.stream = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-scan__mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-scan {
  width: 100%;
  max-width: 480px;
  color: #fff;

  &__head {
    display: flex;
    align-items: center;
    padding: 8px 8px 8px 16px;

    span {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
    }
  }

  &__close {
    width: 44px;
    height: 44px;
    border: 0;
    background: none;
    color: #fff;
    cursor: pointer;
  }

  &__video {
    width: 100%;
    max-height: 60vh;
    object-fit: cover;
    border-radius: 8px;
  }

  &__hint,
  &__unsupported {
    text-align: center;
    font-size: 14px;
    padding: 14px 16px;
    color: rgba(255, 255, 255, 0.85);
  }
}
</style>
